var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-component',{staticClass:"m-t-15",attrs:{"model_name":"buyer","placeholder":"Buscar chat"},on:{"setSelected":_vm.setSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }